import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectCustomerPayment = (state: RootState) => state.customerPayment;

const selectCustomerPaymentParams = createSelector(
  selectCustomerPayment,
  (state) => {
    return state.params;
  }
);

const selectCustomerPaymentComputation = createSelector(
  selectCustomerPayment,
  (state) => {
    return state.customer_computation_state;
  }
);

const selectCustomerPaymentList = createSelector(
  selectCustomerPayment,
  (state) => {
    return state.customer_payment_list_state;
  }
);

export const selectors = {
  selectCustomerPaymentParams,
  selectCustomerPaymentComputation,
  selectCustomerPaymentList
};
